class DateService {
  public static getHumanizedDate(date: string) {
    const formatter = new Intl.RelativeTimeFormat("en", { numeric: "auto" });
    const currentTime = new Date();
    const diff: number = currentTime.getTime() - new Date(date).getTime();
    const seconds: number = Math.floor(diff / 1000);
    const minutes: number = Math.floor(seconds / 60);
    const hours: number = Math.floor(minutes / 60);
    const days: number = Math.floor(hours / 24);
    const months: number = Math.floor(days / 30);
    const years: number = Math.floor(days / 365);

    if (seconds < 60) {
      return formatter.format(-seconds, "second");
    }

    if (minutes < 60) {
      return formatter.format(-minutes, "minute");
    }

    if (hours < 24) {
      return formatter.format(-hours, "hour");
    }

    if (days < 30) {
      return formatter.format(-days, "day");
    }

    if (months < 12) {
      return formatter.format(-months, "month");
    }

    return formatter.format(-years, "year");
  }
}

export default DateService;
